<template>
  <div class="relative z-50">
    <div
      class="w-7 h-7 bg-truegray-300 hover:bg-truegray-700 rounded-full p-2 text-white cursor-pointer transition-all duration-100 relative"
      @click.stop="toggleMenu(report.id)"
    >
      <div
        class="absolute inset-0 w-full h-full flex justify-center items-center z-20"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
          />
        </svg>
      </div>
    </div>
    <ul
      :class="[
        active
          ? 'opacity-100 pointer-events-all translate-y-0'
          : '-translate-y-8 opacity-0 pointer-events-none',
      ]"
      class="absolute top-[-2rem] right-8 mt-4 rounded shadow-xl right-0 bg-white text-truegray-500 transform transition-all duration-300 ease-in-out w-40 z-50"
    >
      <li
        v-for="action in actions"
        :key="action.name"
        :class="
          action.name === 'remove'
            ? 'text-red-400 hover:text-red-600'
            : 'hover:text-black'
        "
        class="hover:bg-truegray-300 p-4 cursor-pointer border-b border-truegray-300"
        @click.stop="() => action.callback()"
      >
        {{ action.title }}
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useStore } from '../../../../js/store/index.js'
import { EventBus } from '../../../../js/plugins/event-bus'
// import * as loadingAnimation

export default defineComponent({
  name: 'ReportActionMenu',

  props: {
    report: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const store = useStore()
    const router = useRouter()

    const active = ref(false)
    const toggleMenu = (id) => {
      // @todo surely there's a better way of dealing with multiple menus
      if (id === props.report?.id && active.value === true) {
        active.value = false
      } else {
        EventBus.$emit('closeOtherReportManagerMenus')
        active.value = !active.value
      }
    }

    const actions = computed(() => [
      {
        name: 'edit',
        title: 'Edit report',
        callback: () => {
          router.push({
            name: 'ManagerUpdateReport',
            query: {
              id: props.report.id,
            },
          })
        },
      },

      {
        name: 'remove',
        title: 'Remove',
        callback: async () => {
          await store.dispatch('connections/dispatchRemoveReport', {
            reportId: props.report.id,
          })
        },
      },
    ])

    onMounted(() => {
      EventBus.$on('closeOtherReportManagerMenus', () => {
        active.value = false
      })
    })

    return { active, toggleMenu, actions }
  },
})
</script>
